import { View } from '@smarterservices/smarter-ui';
import useAppStore from '../../stores/app';
import AwaitingCheckin from './waiting';
import InReview from './active';
import Reconnect from './reconnect';
import SentBack from './SentBack';
import RecentlyExited from './RecentlyExited';

const Checkin = () => {
  const drawerWidth = useAppStore((state) => state.drawerWidth);

  return (
    <View
      as="div"
      id="CheckinContainer"
      maxWidth={drawerWidth}
      minWidth={drawerWidth}
      padding="small"
    >
      <View as="div" margin="none none xx-small none">
        <AwaitingCheckin expanded={false} />
      </View>
      <View as="div" margin="none none xx-small none">
        <InReview expanded={false} />
      </View>
      <View as="div" margin="none none xx-small none">
        <Reconnect expanded={false} />
      </View>
      <View as="div" margin="none none xx-small none">
        <SentBack expanded={false} />
      </View>
      <View as="div" margin="none none xx-small none">
        <RecentlyExited expanded={false} />
      </View>
    </View>
  );
};

export default Checkin;
